import { moviesApi } from "../../api";
import React from "react";
import HomePresenter from "./HomePresenter";

// eslint-disable-next-line import/no-anonymous-default-export
export default class extends React.Component {
  //state값들을 설정한다.
  state = {
    nowPlaying: null,
    upcoming: null,
    popular: null,
    error: null,
    loading: true,
  };

  // async, await을 사용하여 구현한다.
  // nowplaying이 영화를 가져오는 것을 api가 리턴될 때까지 기다리지 않아서
  // 기다리게끔 해주는 것이다.
  async componentDidMount() {
    try {
      // 객체 비구조화 할당.
      // moviesApi.nowPlaying()에서 가져온 데이터들 중
      // data 속 results 속 nowPlaying을 가져온다.
      const {
        data: { results: nowPlaying },
      } = await moviesApi.nowPlaying();
      console.log(nowPlaying);
      const {
        data: { results: upcoming },
      } = await moviesApi.upcoming();
      const {
        data: { results: popular },
      } = await moviesApi.popular();
      this.setState({
        nowPlaying,
        upcoming,
        popular,
      });
    } catch {
      // catch일 때는 오류를 보낸다.
      this.setState({
        error: "Can't find movies information.",
      });
    } finally {
      // finally 를 사용하여 무조건 실행되게 한다.
      this.setState({
        loading: false,
      });
    }
  }

  // 모든 state 값들을 렌더링 한다.
  render() {
    const { nowPlaying, upcoming, popular, error, loading } = this.state;
    return (
      <HomePresenter
        nowPlaying={nowPlaying}
        upcoming={upcoming}
        popular={popular}
        error={error}
        loading={loading}
      />
    );
  }
}
